module.exports = __webpack_public_path__ + "media/assets/icons/two-thumbs-1021cbf3b9e96096ffe8177ab4041268.svg";